import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconMute = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='30'
            viewBox='0 0 30 30'
            width='30'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.44717 18.125V11.875H9.08655L14.4472 6.51468V23.4853L9.08655 18.125H4.44717Z'
                fill={fill}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconMute;
